<template>
  <kaihu-list title="商家开户" :route="route" :config="['cmb']"></kaihu-list>
</template>

<script>
import { KaihuList } from 'zgkaihu'
export default {
  name: 'AccountKaihuIndex',
  components: { KaihuList },
  data() {
    return {
      route: {
        cmb: {
          apply: { name: 'AccountKaihuCmb' },
          result: { name: 'AccountKaihuResult' }
        },
        piaoju: {
          apply: { name: 'AccountKaihuPiaoju' },
          result: { name: 'AccountKaihuResult' }
        },
        huifu: {
          apply: { name: 'AccountKaihuHuifu' },
          result: { name: 'AccountKaihuResult' }
        },
        tenpaySeller: {
          apply: { name: 'AccountKaihuTenpay' },
          result: { name: 'AccountKaihuTenpay' }
        },
        home: { name: 'fundAccountHome' }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.box-card {
  position: relative;
  width: 450px;
  min-height: 180px;
  text-align: center;
}
.title {
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 0 0;
}
.span-position {
  position: absolute;
  transform: rotate(45deg);
  top: 15px;
  right: 0;
}
.fixposition {
  top: 23px;
  right: -4px;
}
.btn-position {
  position: absolute;
  left: 50%;
  bottom: 24px;
  transform: translateX(-50%);
}
</style>
